/**
 * Header Drawer Menu — Luxury Slide-In Nav
 * With third-level artist showcase carousel
 */
document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('HeaderDrawerMenu');
  if (!drawer) return;

  var backdrop = drawer.querySelector('.hdm__backdrop-state');
  var closeBtn = drawer.querySelector('.hdm__shop-label');
  var navScroll = drawer.querySelector('.hdm__nav-scroll');
  var navLinks = drawer.querySelectorAll('.hdm__nav-link[data-handle]');
  var reveal = drawer.querySelector('.hdm__reveal');
  var revealPanels = drawer.querySelectorAll('.hdm__reveal-panel');
  var revealDefault = drawer.querySelector('.hdm__reveal-default');
  var rightPane = drawer.querySelector('[data-right-pane]');
  var teaserVideo = drawer.querySelector('.hdm__teaser-video');

  /* Showcase elements */
  var showcaseImg = drawer.querySelector('[data-showcase-image]');
  var showcaseDots = drawer.querySelector('[data-showcase-dots]');
  var showcaseLink = drawer.querySelector('[data-showcase-link]');
  var showcaseLinkLabel = drawer.querySelector('[data-showcase-link-label]');
  var showcaseCaption = drawer.querySelector('[data-showcase-caption]');
  var showcaseWorkTitle = drawer.querySelector('[data-showcase-work-title]');
  var showcaseArtistName = drawer.querySelector('[data-showcase-artist-name]');

  /* Load subfeature data from JSON */
  var subfeatures = {};
  var sfEl = document.getElementById('hdm-subfeatures');
  if (sfEl) {
    try {
      var sfData = JSON.parse(sfEl.textContent);
      sfData.forEach(function (sf) { subfeatures[sf.handle] = sf; });
    } catch (e) { /* ignore */ }
  }

  var hoverTimer = null;
  var HOVER_DELAY = 100;
  var carouselTimer = null;
  var carouselIndex = 0;
  var currentShowcase = null;

  /* ── Open / Close ── */

  function open() {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('drawer-blur-active');
    if (teaserVideo) teaserVideo.play().catch(function () {});
  }

  function close() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('drawer-blur-active');
    if (teaserVideo) teaserVideo.pause();
    resetReveal();
    resetShowcase();
  }

  function toggle() {
    drawer.classList.contains('is-open') ? close() : open();
  }

  document.addEventListener('drawer:open', toggle);
  var shopTrigger = document.querySelector('.shop-drawer-trigger');
  if (shopTrigger) {
    shopTrigger.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); toggle();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });
  if (backdrop) backdrop.addEventListener('click', close);
  if (rightPane) rightPane.addEventListener('click', function (e) {
    if (e.target === rightPane || e.target.closest('.hdm__backdrop-state') || e.target.closest('.hdm__teaser-overlay')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* ── Reveal Pane ── */

  function activateReveal(handle) {
    var match = null;
    revealPanels.forEach(function (p) {
      if (p.getAttribute('data-reveal') === handle && p.childElementCount > 0) match = p;
      p.classList.remove('is-active');
    });
    if (revealDefault) revealDefault.classList.remove('is-active');
    if (match) {
      match.classList.add('is-active');
      if (reveal) reveal.classList.add('is-expanded');
    } else {
      if (reveal) reveal.classList.remove('is-expanded');
    }
  }

  function resetReveal() {
    clearTimeout(hoverTimer);
    revealPanels.forEach(function (p) { p.classList.remove('is-active'); });
    if (revealDefault && revealDefault.childElementCount > 0) {
      revealDefault.classList.add('is-active');
      if (reveal) reveal.classList.add('is-expanded');
    } else {
      if (reveal) reveal.classList.remove('is-expanded');
    }
    navLinks.forEach(function (l) { l.classList.remove('is-active'); });
  }

  navLinks.forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () {
        activateReveal(link.getAttribute('data-handle'));
        navLinks.forEach(function (l) { l.classList.remove('is-active'); });
        link.classList.add('is-active');
        resetShowcase();
      }, HOVER_DELAY);
    });
  });

  if (navScroll) {
    navScroll.addEventListener('mouseleave', function () {
      resetReveal();
      resetShowcase();
    });
  }

  /* ── Showcase Carousel ── */

  function showShowcase(sf) {
    if (!rightPane || !showcaseImg) return;
    currentShowcase = sf;
    carouselIndex = 0;
    renderSlide(0);

    /* Build dots */
    if (showcaseDots) {
      while (showcaseDots.firstChild) showcaseDots.removeChild(showcaseDots.firstChild);
      if (sf.works.length > 1) {
        sf.works.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.className = 'hdm__showcase-dot' + (i === 0 ? ' is-active' : '');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Show work ' + (i + 1));
          dot.addEventListener('click', function (e) {
            e.preventDefault();
            carouselIndex = i;
            renderSlide(i);
            restartCarousel();
          });
          showcaseDots.appendChild(dot);
        });
      }
    }

    /* Link */
    if (showcaseLink) {
      showcaseLink.style.display = sf.viewLink ? '' : 'none';
      if (sf.viewLink) {
        showcaseLink.href = sf.viewLink;
        if (showcaseLinkLabel) showcaseLinkLabel.textContent = sf.viewLabel;
      }
    }

    rightPane.setAttribute('data-active', 'showcase');
    startCarousel();
  }

  function resetShowcase() {
    if (!rightPane) return;
    currentShowcase = null;
    stopCarousel();
    rightPane.setAttribute('data-active', 'backdrop');
    if (showcaseCaption) showcaseCaption.style.display = 'none';
    if (showcaseLink) showcaseLink.style.display = 'none';
  }

  function renderSlide(i) {
    if (!currentShowcase || !currentShowcase.works[i]) return;
    var w = currentShowcase.works[i];
    if (showcaseImg) { showcaseImg.src = w.image; showcaseImg.alt = w.title || ''; }

    /* Caption */
    if (showcaseCaption) {
      var ht = w.title && w.title.trim();
      var hn = currentShowcase.artistName && currentShowcase.artistName.trim();
      if (ht || hn) {
        if (showcaseWorkTitle) showcaseWorkTitle.textContent = w.title || '';
        if (showcaseArtistName) showcaseArtistName.textContent = currentShowcase.artistName || '';
        showcaseCaption.style.display = '';
        var sep = showcaseCaption.querySelector('.hdm__showcase-sep');
        if (sep) sep.style.display = (ht && hn) ? '' : 'none';
      } else {
        showcaseCaption.style.display = 'none';
      }
    }

    /* Dots active */
    if (showcaseDots) {
      var dots = showcaseDots.querySelectorAll('.hdm__showcase-dot');
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
  }

  function startCarousel() {
    stopCarousel();
    if (!currentShowcase || currentShowcase.works.length <= 1) return;
    carouselTimer = setInterval(function () {
      carouselIndex = (carouselIndex + 1) % currentShowcase.works.length;
      renderSlide(carouselIndex);
    }, 4000);
  }

  function stopCarousel() { if (carouselTimer) { clearInterval(carouselTimer); carouselTimer = null; } }
  function restartCarousel() { stopCarousel(); startCarousel(); }

  /* Pause on hover */
  var scState = drawer.querySelector('[data-state="showcase"]');
  if (scState) {
    scState.addEventListener('mouseenter', stopCarousel);
    scState.addEventListener('mouseleave', function () { if (currentShowcase) startCarousel(); });
  }

  /* Sub-link hover triggers showcase */
  drawer.querySelectorAll('.hdm__sub-link[data-has-showcase]').forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      var h = link.getAttribute('data-child-handle');
      if (h && subfeatures[h]) showShowcase(subfeatures[h]);
    });
    link.addEventListener('mouseleave', function (e) {
      var rel = e.relatedTarget ? e.relatedTarget.closest('.hdm__sub-link[data-has-showcase]') : null;
      if (!rel) resetShowcase();
    });
  });

  /* ── Mobile Accordion ── */

  navLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (window.innerWidth >= 768) return;
      var item = link.closest('.hdm__nav-item');
      if (!item) return;
      var acc = item.querySelector('.hdm__accordion-content');
      if (!acc) return;
      e.preventDefault();
      var wasOpen = item.classList.contains('is-expanded');
      drawer.querySelectorAll('.hdm__nav-item.is-expanded').forEach(function (el) { el.classList.remove('is-expanded'); });
      if (!wasOpen) item.classList.add('is-expanded');
    });
  });

  /* ── Focus Trap ── */

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    var focusable = Array.prototype.slice.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')
    );
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
});
